export default "__VITE_ASSET__B4fM1ti9__"